export const TOGGLE_FILTER_SELECTION = 'toggle-filter-selection'
export const UPDATE_TIME_MACHINE = 'update-time-machine'
export const SUBSEA_FILTER = 'subsea-filter'
